export default __webpack_public_path__ + "static/media/hht1_ep16_book_wp_02.f6aee066.jpg";